import api from './axios';
import { ApiResponse, DashboardStats, User } from '../types';

export const adminAPI = {
  getDashboardStats: async () => {
    const res = await api.get<ApiResponse<DashboardStats>>('/api/admin/dashboard');
    return res.data;
  },

  // Users
  getAllUsers: async () => {
    const res = await api.get<ApiResponse<User[]>>('/api/admin/users');
    return res.data;
  },

  updateUserRole: async (id: string, role: string) => {
    const res = await api.put<ApiResponse<{}>>(`/api/admin/users/${id}/role`, { role });
    return res.data;
  },

  deleteUser: async (id: string) => {
    const res = await api.delete<ApiResponse<{}>>(`/api/admin/users/${id}`);
    return res.data;
  },

  // Orders
  getAllOrders: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/admin/orders');
    return res.data;
  },

  // Inventory
  getInventory: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/admin/inventory');
    return res.data;
  },

  updateStock: async (id: string, stock_quantity: number) => {
    const res = await api.put<ApiResponse<{}>>(`/api/admin/inventory/${id}`, { stock_quantity });
    return res.data;
  },

  // Settings
  getSiteSettings: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/admin/settings');
    return res.data;
  },

  updateSiteSetting: async (data: {
    key: string;
    value: string;
    description?: string;
  }) => {
    const res = await api.post<ApiResponse<{}>>('/api/admin/settings', data);
    return res.data;
  },

  // Logs
  getActivityLogs: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/admin/logs');
    return res.data;
  },

  // Reviews
  approveReview: async (id: string, is_approved: boolean) => {
    const res = await api.put<ApiResponse<{}>>(`/api/reviews/${id}/approve`, { is_approved });
    return res.data;
  },

  // Discounts
  getAllDiscounts: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/discounts');
    return res.data;
  },

  createDiscount: async (data: any) => {
    const res = await api.post<ApiResponse<{}>>('/api/discounts', data);
    return res.data;
  },

  updateDiscount: async (id: string, data: any) => {
    const res = await api.put<ApiResponse<{}>>(`/api/discounts/${id}`, data);
    return res.data;
  },

  deleteDiscount: async (id: string) => {
    const res = await api.delete<ApiResponse<{}>>(`/api/discounts/${id}`);
    return res.data;
  },

  // Shipping
  getAllShipping: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/shipping/all');
    return res.data;
  },

  createShipping: async (data: any) => {
    const res = await api.post<ApiResponse<{}>>('/api/shipping', data);
    return res.data;
  },

  updateShipping: async (id: string, data: any) => {
    const res = await api.put<ApiResponse<{}>>(`/api/shipping/${id}`, data);
    return res.data;
  },

  deleteShipping: async (id: string) => {
    const res = await api.delete<ApiResponse<{}>>(`/api/shipping/${id}`);
    return res.data;
  },

  // Newsletter
  getSubscribers: async () => {
    const res = await api.get<ApiResponse<any[]>>('/api/newsletter/subscribers');
    return res.data;
  },

  // Campaigns
  getCampaigns: async () => {
    const res = await api.get('/api/campaigns');
    return res.data;
  },

  getNotifications: async () => {
  const res = await api.get('/api/notifications');
  return res.data;
},

markNotificationRead: async (id: string) => {
  const res = await api.put(`/api/notifications/${id}/read`);
  return res.data;
},

markAllNotificationsRead: async () => {
  const res = await api.put('/api/notifications/mark-all-read');
  return res.data;
},
getContactMessages: async () => {
  const res = await api.get('/api/contact');
  return res.data;
},

markMessageRead: async (id: string) => {
  const res = await api.put(`/api/contact/${id}/read`);
  return res.data;
},

deleteContactMessage: async (id: string) => {
  const res = await api.delete(`/api/contact/${id}`);
  return res.data;
},

  createCampaign: async (data: {
    subject: string;
    template_id: string;
    content_html: string;
    scheduled_at?: string;
  }) => {
    const res = await api.post('/api/campaigns', data);
    return res.data;
  },

  updateCampaign: async (id: string, data: any) => {
    const res = await api.put(`/api/campaigns/${id}`, data);
    return res.data;
  },

  deleteCampaign: async (id: string) => {
    const res = await api.delete(`/api/campaigns/${id}`);
    return res.data;
  },

  sendCampaignNow: async (id: string) => {
    const res = await api.post(`/api/campaigns/${id}/send`);
    return res.data;
  },
};